import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import auth from 'services/auth';

export default function useLoginPage() {
  const { setUser, setLoading } = useContext(GlobalContext);
  const history = useHistory();
  const [error, setError] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    const { login, senha } = e.target;

    try {
      setLoading(true);
      const { error, user } = await auth.login(login.value, senha.value);
      setLoading(false);
      if (!error) {
        setUser({ isAuthenticated: true, ...user });
        history.push('/');
      } else {
        throw new Error(error.message);
      }
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setTimeout(() => setError(null), 2000);
    }
  }

  return { error, onSubmit };
}
